import HttpRequest from '@/config/axios.config'
import {
  createPropertyRef,
  defectListRef,
  deletePropertyRef,
  deletePropertyValueRef,
  deleteSupplierRef,
  getPropertiesRef,
  getPropertyDetailRef,
  getPropertyValueRef,
  getSupplierRef,
  saveDefectListRef,
  savePropertyValuesRef,
  saveSupplierRef,
  updateDefectListRef,
  updatePropertyRef,
  updatePropertyValueRef,
  updateSupplierRef,
  getCountryRef,
  defectItemRef,
  saveDefectItemRef,
  updateDefectItemRef,
  deleteDefectGroup,
  getPropertyValueInspectionTypeRef,
  getPropertyValueInspectionBrandRef,
} from './DataManagement.service'
import { JSONStringify, isEmptyValue } from '@/utils/common'
import FormDataLib from 'form-data'
import { map } from 'lodash'

export const getSupplier = async (payload) => {
  return (await getSupplierRef(payload)).data
}

export const getCountry = async () => {
  return (await getCountryRef()).data?.map((item) => {
    return {
      label: item.name,
      value: JSONStringify(item),
    }
  })
}

export const getDefectList = async (data: any) => {
  return (await defectListRef(data)).data
}

export const getDefectItem = async (id: any) => {
  return (await defectItemRef(id)).data
}

export async function saveInspectionType(id: string, data: any) {
  const payload = {
    table: 'properties',
    field: 'inspectionType',
    data_type: 'json',
    values: [data],
  }
  return await savePropertyValuesRef(id, payload)
}

export async function saveInspectionAQL(
  propertyId: string,
  data: any,
  is_default
) {
  const payload = {
    table: 'properties',
    field: 'aql',
    data_type: 'json',
    is_default,
    values: [data],
  }
  return await savePropertyValuesRef(propertyId, payload)
}

export async function getProperties() {
  return (await getPropertiesRef()).data?.data
    ?.filter((item) => item.name !== 'aql' && item.name !== 'inspectionType')
    .reverse()
}

export async function createProperty(data: any) {
  return await createPropertyRef(data)
}

export async function updateProperty(id: string, data: any) {
  return await updatePropertyRef(id, data)
}

export async function getPropertyDetail(id: string) {
  return (await getPropertyDetailRef(id))?.data.data
}

export async function getInspectionAQL(data) {
  return (await getPropertyValueRef(data))?.data?.data
}

export async function getPropertyValueInspectionType() {
  const data = await getPropertyValueInspectionTypeRef()
  const result = map(data, ({ id, value }: any) => {
    const wrapData = {
      id,
      value: JSON.parse(value) || {},
    }
    return wrapData
  })
  return result
}

export async function getPropertyValueInspectionBrand() {
  const data = await getPropertyValueInspectionBrandRef()
  const result = map(data, ({ id, value = '' }: any) => {
    const wrapData = {
      id,
      value,
    }
    return wrapData
  })
  return result
}

export async function getInspectionType(data) {
  return (await getPropertyValueRef(data))?.data?.data
}

export async function updateInspectionAQL(id, data, is_default) {
  const payload = {
    value: JSONStringify(data),
    is_default,
  }
  return await updatePropertyValueRef(id, payload)
}

export async function updateInspectionType(id, data) {
  const payload = {
    value: JSONStringify(data),
  }
  await updatePropertyValueRef(id, payload)
}

export async function deletePropertyValue(id: string) {
  await deletePropertyValueRef(id)
}

export async function savePropertyValue(propertyId, PropertyName, data) {
  const payload = {
    table: 'properties',
    field: PropertyName,
    data_type: 'string',
    values: [data],
  }
  return await savePropertyValuesRef(propertyId, payload)
}

export async function updatePropertyValue(id, data) {
  const payload = {
    value: data,
  }
  await updatePropertyValueRef(id, payload)
}

export async function uploadSupplierDocuments(documents) {
  const formData: any = new FormDataLib()
  const uploadedFile = []
  if (!isEmptyValue(documents)) {
    for (const file of documents) {
      if (file.originFileObj) {
        formData.append('files', file.originFileObj)
      } else {
        uploadedFile.push(file)
      }
    }
  }
  if (formData.has('files')) {
    const newUploadedFiles = (
      await HttpRequest.post(`medias/multiple/orders`, formData, {
        headers: {
          [`Content-Type`]: `multipart/form-data`,
        },
      })
    )?.data?.data
    newUploadedFiles?.forEach((item) => {
      uploadedFile.push(item)
    })
  }
  return uploadedFile
}

export async function saveSupplier(payload) {
  const data = await saveSupplierRef(payload)
  if (String(data?.data?.statusCode).includes('20')) {
  } else {
    return data
  }
}

export async function updateSupplier(id, payload) {
  const data = await updateSupplierRef(id, payload)
  if (String(data?.data?.statusCode).includes('20')) {
  } else {
    return data
  }
}

export async function deleteSupplier(data: any) {
  const payload = {
    id: data?.id,
    name: data?.name,
    type: data?.type,
    email: data?.email,
    status: 'archive',
    parent: data?.parent?.id,
  }
  return await deleteSupplierRef(payload)
}

export async function saveDefectList(data: any) {
  await saveDefectListRef(data)
}

export async function saveDefectItem(data: any) {
  await saveDefectItemRef(data)
}

export async function updateDefectItem(id: string, data: any) {
  await updateDefectItemRef(id, data)
}

export async function updateDefectList(id: string, data: any) {
  await updateDefectListRef(id, data)
}

export async function deleteDefectList(data: any) {
  return await deleteDefectGroup(data.id)
}

export async function deleteDefectItem(data: any) {
  const tmp = {
    name: data.name,
    status: 'inactive',
    defect_group_id: data.defect_group_id,
  }
  await updateDefectItemRef(data.id, tmp)
}

export async function deleteProperty(id: string) {
  await deletePropertyRef(id)
}
